import { useMemo } from 'react';
import { Typography } from '@mui/material';
import { computeWordDiff } from '@/components/common/diff-text.utils';

export function DiffText({ oldStr, newStr }: { oldStr: string; newStr: string }) {
  const segments = useMemo(() => computeWordDiff(oldStr, newStr), [oldStr, newStr]);
  return (
    <Typography
      variant="body2"
      component="span"
      sx={{ fontSize: '0.8125rem', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}
    >
      {segments.map((seg, idx) => {
        if (seg.type === 'equal') return <span key={idx}>{seg.text}</span>;
        if (seg.type === 'added')
          return (
            <span key={idx} style={{ backgroundColor: 'rgba(46, 160, 67, 0.15)', borderRadius: 2, padding: '0 1px' }}>
              {seg.text}
            </span>
          );
        return (
          <span
            key={idx}
            style={{
              backgroundColor: 'rgba(248, 81, 73, 0.15)',
              textDecoration: 'line-through',
              borderRadius: 2,
              padding: '0 1px',
            }}
          >
            {seg.text}
          </span>
        );
      })}
    </Typography>
  );
}
